import { render, staticRenderFns } from "./AffiliateReportsIndex.vue?vue&type=template&id=74890631&"
import script from "./AffiliateReportsIndex.vue?vue&type=script&lang=js&"
export * from "./AffiliateReportsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports